import Layout from '../../Layout'
import DashboardOverview from '../../components/Home/DashboardOverview'
import BlockVoucherProduct from '../../components/Home/BlockVoucherProduct'
import BlockProductHighProfit from 'components/Home/BlockProductHighProfit'
import BclockProductPurchased from 'components/Home/BclockProductPurchased'
import JustForYouBlock from 'components/Home/JustForYouBlock'
import HomeSlider from '../../components/Home/NoneLogin/HomeSlider'
import UuDaiHangHang from 'components/Home/NoneLogin/UuDaiHangHang'
import DoiTac from 'components/Home/NoneLogin/DoiTac'
import CauHoi from 'components/Home/NoneLogin/CauHoi'
import YKienKhachHang from 'components/Home/NoneLogin/YKienKhachHang'
import NhanUuDai from 'components/Home/NoneLogin/NhanUuDai'
import LazySection from 'components/LazySection'

export default function IndexNoneLogin() {
    return (
        <div className="bg-white">
            <div className="container-full mx-auto px-0 space-y-4 overflow-hidden relative">
                <HomeSlider />
            </div>
            <div className="container mx-auto py-4 px-0 space-y-4">
                <BlockVoucherProduct />
            </div>
            <LazySection rootMargin="300px" minHeight={300}>
                <div className="container-full mx-auto px-0 space-y-4 overflow-hidden relative" style={{ backgroundColor: "rgba(21, 169, 89, 0.1)" }}>
                    <div className="container mx-auto px-0 space-y-4 mt-4">
                        <UuDaiHangHang />
                    </div>
                </div>
            </LazySection>
            <LazySection rootMargin="200px" minHeight={300}>
                <div className="container mx-auto py-4 px-0 space-y-4">
                    <DoiTac />
                </div>
            </LazySection>
            <LazySection rootMargin="200px" minHeight={200}>
                <div className="container-full mx-auto px-0 space-y-4 overflow-hidden relative" style={{ backgroundColor: "rgba(21, 169, 89, 0.1)" }}>
                    <div className="container mx-auto px-0 space-y-4">
                        <CauHoi />
                    </div>
                </div>
            </LazySection>
            <LazySection rootMargin="200px" minHeight={300}>
                <div className="container mx-auto py-4 px-0 space-y-4">
                    <YKienKhachHang />
                </div>
            </LazySection>
            <LazySection rootMargin="200px" minHeight={150}>
                <div className="styles_wrapper__2377Z container-full mx-auto px-0 space-y-4 overflow-hidden relative">
                    <div className="container mx-auto px-0 space-y-4">
                        <NhanUuDai />
                    </div>
                </div>
            </LazySection>
        </div>
    )
}
